import { create } from 'zustand';

import { EMetricsManagementTabsType } from '@src/common/constant/enum';
import { createSetState } from '@src/emp-3.0/utils/management';

interface IMetricsSubTab {
  activeTabKey: EMetricsManagementTabsType;
  setActiveTabKey: (activeTabKey: EMetricsManagementTabsType) => void;
}

export const useMetricsSubTabStore = create<IMetricsSubTab>((set) => ({
  activeTabKey: EMetricsManagementTabsType.INDIVIDUAL_METRICS,
  setActiveTabKey: createSetState(set, 'activeTabKey'),
}));
